<div *ngIf="activeBehavior"> {{activeBehavior.name}}</div>
